import React from 'react';
import PageManagerProvider from './contexts/PageManager/Provider';
import Page from './page';

export default function Settings() {
  return (
    <PageManagerProvider>
      <Page />
    </PageManagerProvider>
  );
}
